import { PPFE_0016_GROUP_PARAMETER_KEY, PPFE_0016_GROUP_PARAMETER_OPTIONS, PPFE_0016_TREATMENT_KEY } from '../../constants/experimentKeys';
import { logExperimentExposure, useExperimentEffect } from './experimentUtils';
export const logPPFE0016Exposure = () => {
  logExperimentExposure(PPFE_0016_TREATMENT_KEY);
};
const usePPFE0016EligibilityCondition = ({
  isPreview,
  hasTierCards
}) => {
  const isConditionMet = !isPreview && hasTierCards;
  return {
    isConditionMet
  };
};

/**
 * Call this hook from the page or component where the experiment applies.
 *
 * When the visitor is eligible, exposure is logged once per session and the
 * treatment is registered as a public eligible treatment. Branch on the
 * returned `group` by comparing it with PPFE_0016_GROUP_PARAMETER_OPTIONS.
 *
 * The cohort is sticky for the SPA session (intent-to-treat). Whether the
 * variant *renders* on a given page is a separate component-level concern.
 * See arbor docs/experiments.mdx for details.
 */
export const usePPFE0016ExperimentEffect = input => {
  const eligibilityCondition = usePPFE0016EligibilityCondition(input);
  const experiment = useExperimentEffect({
    treatmentKey: PPFE_0016_TREATMENT_KEY,
    groupParameterKey: PPFE_0016_GROUP_PARAMETER_KEY,
    groupParameterOptions: PPFE_0016_GROUP_PARAMETER_OPTIONS,
    experimentEligibilityCondition: () => eligibilityCondition,
    shouldLogExposure: true
  });
  if (!input.isPreview) {
    return experiment;
  }
  return Object.assign({}, experiment, {
    isEligible: true,
    group: PPFE_0016_GROUP_PARAMETER_OPTIONS.variation
  });
};